export default __webpack_public_path__ + "static/media/Penny Bun8.55d70924.jpg";